import {
  PriceSummary,
  PriceSummaryRow
} from '@ps-design-system/components/PriceSummary';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export const AttendeePricingSummary = ({ attendeePricingTiers, currency }) => {
  return (
    <PriceSummary testId="calendar-pricing-summary" textSize="large">
      {(attendeePricingTiers || []).map((tier, i) => (
        <PriceSummaryRow
          key={`${tier.name}-${i}`}
          testId={`calendar-pricing-rule-${i}`}
          name={(
            <FormattedMessage
              id="attendee_pricing_summary.range"
              defaultMessage="{min} - {max} people"
              values={{
                min: tier.min,
                max: tier.max
              }}
            />
          )}
          value={(
            <FormattedMessage
              id="attendee_pricing_summary.per_hour"
              defaultMessage="+{rate}/hr"
              values={{
                rate: (
                  <FormattedNumber
                    value={tier.value}
                    currency={currency}
                    style="currency"
                    minimumFractionDigits={0}
                    maximumFractionDigits={0}
                  />
                )
              }}
            />
          )}
        />
      ))}
    </PriceSummary>
  );
};
AttendeePricingSummary.displayName = 'AttendeePricingSummary';
AttendeePricingSummary.propTypes = {
  attendeePricingTiers: PropTypes.array,
  currency: PropTypes.string
};
